import dayjs from 'dayjs';
import { TASK_ARCHIVE_AGE_IN_DAYS, TASK_DELETE_AGE_IN_MONTHS } from '../constants';

export type TaskArchivalPeriods = {
  includesActivePeriod: boolean;
  includesArchivedPeriod: boolean;
  includesDeletedPeriod: boolean;
  isMixedActiveArchived: boolean;
  isAllArchived: boolean;
  isAllDeleted: boolean;
  isMixedArchivedDeleted: boolean;
  isMixedActiveArchivedDeleted: boolean;
};

const EMPTY_TASK_ARCHIVAL_PERIODS: TaskArchivalPeriods = {
  includesActivePeriod: false,
  includesArchivedPeriod: false,
  includesDeletedPeriod: false,

  isMixedActiveArchived: false,
  isAllArchived: false,
  isAllDeleted: false,
  isMixedArchivedDeleted: false,
  isMixedActiveArchivedDeleted: false,
};

export const getTaskArchivalPeriods = ({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): TaskArchivalPeriods => {
  const normalizedStartDate = startDate ? dayjs(startDate).startOf('day') : null;
  const normalizedEndDate = endDate ? dayjs(endDate).startOf('day') : null;

  if (!normalizedStartDate?.isValid() || !normalizedEndDate?.isValid()) {
    return EMPTY_TASK_ARCHIVAL_PERIODS;
  }

  const archiveThreshold = dayjs().subtract(TASK_ARCHIVE_AGE_IN_DAYS, 'day').startOf('day');

  const deleteThreshold = dayjs().subtract(TASK_DELETE_AGE_IN_MONTHS, 'month').startOf('day');

  const includesActivePeriod = normalizedEndDate.isAfter(archiveThreshold);

  const includesArchivedPeriod =
    !normalizedStartDate.isAfter(archiveThreshold) && normalizedEndDate.isAfter(deleteThreshold);

  const includesDeletedPeriod = !normalizedStartDate.isAfter(deleteThreshold);

  return {
    includesActivePeriod,
    includesArchivedPeriod,
    includesDeletedPeriod,
    isMixedActiveArchived: includesActivePeriod && includesArchivedPeriod && !includesDeletedPeriod,
    isAllArchived: !includesActivePeriod && includesArchivedPeriod && !includesDeletedPeriod,
    isAllDeleted: !includesActivePeriod && !includesArchivedPeriod && includesDeletedPeriod,
    isMixedArchivedDeleted: !includesActivePeriod && includesArchivedPeriod && includesDeletedPeriod,
    isMixedActiveArchivedDeleted: includesActivePeriod && includesArchivedPeriod && includesDeletedPeriod,
  };
};
